








import { Vue, Watch } from "vue-property-decorator";
import Component from "vue-class-component";
import { Mutation } from "vuex-class";

import AppTopNavbar from "@/components/ui/AppTopNavbar.vue";
import { addNotification, NotificationType } from "@/models/notification.model";
import { capitalizeFilter } from "@/filters/capitalize.filter";
import { I18nMessageKey } from "@/enums/i18n-message-key.enum";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Main app component
 */
@Component({
  components: { AppTopNavbar },
  filters: {
    ...capitalizeFilter
  }
})
export default class AppPage extends Vue {
  @Mutation("app/setTitlePrefix") setTitlePrefix!: (newPrefix: string) => void;
  @Watch("$route", { immediate: true }) private routeUpdated(): void {
    const { noFalconSession, expiredPayments } = this.$route.query;
    if (noFalconSession) {
      this.showNoFalconSessionToast();
    }
    if (expiredPayments) {
      this.showExpiredPaymentsToast();
    }
  }

  created(): void {
    this.setTitlePrefix("Strefa użytkownika");
  }

  private showNoFalconSessionToast(): void {
    addNotification({
      message: capitalizeFilter.capitalize(
        this.$t(I18nMessageKey.SharedToastNoFalconSessionText)
      ),
      type: NotificationType.Error
    });
  }

  private showExpiredPaymentsToast(): void {
    addNotification({
      message: capitalizeFilter.capitalize(
        this.$t(I18nMessageKey.SharedToastExpiredPaymentsText)
      ),
      type: NotificationType.Error
    });
  }
}
